<template>
  <Modal v-model="model" sticky reset-drag-position title="客户轨迹查看" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable width="1400" class="customer_trajectory" :styles="{'top':'10px'}">
    <el-timeline>
      <el-timeline-item :timestamp="name" placement="top" icon="el-icon-more" color="#0bbd87" size="large" class="trajectory_name"></el-timeline-item>
      <el-timeline-item  :timestamp="item.createTime" placement="top" v-for="(item,index) in timeContent" :key="index">
        <el-card>
          <h4>操作类型:{{item.trackType}}</h4>
          <p>操作人:{{item.agentNumber}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.trackDesc}}</p>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </Modal>
</template>

<script>
    export default {
      name: "CustomerTrajectoryPop",
      props: {
        showCustomerTrajectory:Boolean,
        trajectoryId:String,
        customerName:String
      },
      data(){
        return{
          model:false,
          timeContent:[],
          name:''
        }
      },
      methods:{
        cancel:function (){
          this.$emit("closeCustomerTrajectory",true);
        },
        searchTrajectory:function () {
          let that=this;
          let param={
            trajectoryId:this.trajectoryId,
            journalType:"null",
            menuId:"null"
          };
          this.$http.post('customer/searchCustomerTrajectoryPop.json',param).then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.timeContent=res.data.obj;
          })
        }
      },
      watch:{
        showCustomerTrajectory:function () {
          this.model=this.showCustomerTrajectory;
          this.name="客户"+this.customerName+"操作轨迹";
          if(this.showCustomerTrajectory){
            this.searchTrajectory();
          }
        }
      }
    }
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/components/customerMange/CustomerTrajectoryPop.vue